import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-special-admitted',
  templateUrl: 'specialAdmitted.component.html',
  styleUrls: ['specialAdmitted.component.scss'],
})

export class SpecialAdmittedComponent  {
  showAdmitted: Boolean;
  @Input() admission: string;

  constructor() { }
}




// WEBPACK FOOTER //
// ./src/app/specialAdmitted/specialAdmitted.component.ts